import { Button, Popconfirm, Tooltip } from "antd";
import { RestartIcon } from "../../icons/restartIcon";
import { useTranslation } from "react-i18next";

export const ClearCacheButton = () => {
  const { t } = useTranslation();

  const handleClearCache = () => {
    // Clear localStorage
    localStorage?.clear();
    // Clear sessionStorage
    sessionStorage?.clear();
    // Clear service worker cache if applicable
    if (window.caches) {
      caches?.keys()?.then((cacheNames) => {
        cacheNames?.forEach((cacheName) => {
          caches?.delete(cacheName);
        });
      });
    }
    // Clear service worker registrations
    if (navigator?.serviceWorker) {
      navigator?.serviceWorker?.getRegistrations()?.then((registrations) => {
        registrations?.forEach((registration) => {
          registration?.unregister();
        });
      });
    }
    // clear indexedDB
    window?.indexedDB?.databases()?.then((r) => {
      for (var i = 0; i < r.length; i++)
        window?.indexedDB?.deleteDatabase(r[i].name || "");
    });
    window.location?.reload();
  };

  return (
    <Tooltip title={t("chatHeader.clearCacheTooltip")}>
      <Popconfirm
        title={t("chatHeader.clearCacheConfirm")}
        onConfirm={handleClearCache}
      >
        <button className="clear-cache-button">
          <RestartIcon />
        </button>
      </Popconfirm>
    </Tooltip>
  );
};
